export function keyApi() {
    let key = '';
    key: 'YBZBZ-2JARJ-5FEFE-XN6OV-ATOQ2-VKBKZ'; //正式
    // key =  "BTBBZ-P7HCB-FIKUQ-JI4TF-SHTKE-3QFQ7"; //测试
    // key: "Z7UBZ-CRM6J-P5XFE-DG2T4-Z7GSO-TDF7H"; //测试2
    return key;
}
